// extracted by mini-css-extract-plugin
module.exports = {"comp":"BannerA_comp__2ThOs"};